import React, { useState, useRef, useEffect } from "react";
import { useDispatch } from "react-redux";
import momentTz from "moment-timezone";
import { useNavigate } from "react-router";
import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import toast from "react-hot-toast";
import {
  cancelOrganizationTariff,
  createTariff,
  createTariffVersion,
  deleteOrganizationSubscription,
  fetchTariffVersions,
  updateOrganizationTariff,
  updateSubscriptionStatus,
} from "../../store/tariffesSlice";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import CloseButton from "../CloseButton/CloseButton";

const OrganizationChangeTariffModal = ({
  orgInfo,
  tariffesArray = [],
  onClose = () => {},
  onSubmit = () => {},
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const [currentChosenTariff, setCurrentChosenTariff] = useState(
    orgInfo?.subscription?.plan || null
  );
  const modalRef = useRef(null);

  // useEffect(() => {
  //   const handleClickOutside = (event) => {
  //     if (
  //       modalRef.current &&
  //       !modalRef.current.contains(event.target) &&
  //       !isLoading
  //     ) {
  //       onClose();
  //     }
  //   };

  //   document.addEventListener("mousedown", handleClickOutside);
  //   return () => {
  //     document.removeEventListener("mousedown", handleClickOutside);
  //   };
  // }, [onClose]);

  // Add keyframes for spinner animation
  const spinnerStyle = document.createElement("style");
  spinnerStyle.innerHTML = `
    @keyframes spin {
      0% { transform: rotate(0deg); }
      100% { transform: rotate(360deg); }
    }
  `;
  document.head.appendChild(spinnerStyle);

  const formatDate = (dateString) => {
    const res = momentTz(dateString)
      .tz("etc/gmt-3")
      .format("DD.MM.YYYY, HH:mm");
    return res;
  };

  const handleSaveChanges = async () => {
    const neededTariff = tariffesArray.find(
      (tariff) => tariff.id === currentChosenTariff
    );
    const currentDate = momentTz().tz("etc/gmt-3").format("YYYY-MM-DD");
    console.log(currentDate);
    console.log(neededTariff);
    const payload = {
      orgId: orgInfo.organizationId,
      tariffData: {
        planVersionPriceId: neededTariff.prices[0].id,
        autoRenew: true,
        startDate: currentDate,
      },
    };

    if (orgInfo.subscription) {
      await dispatch(
        cancelOrganizationTariff({
          orgId: orgInfo.organizationId,
          subscriptionId: orgInfo.subscription.id,
        })
      );
    }
    dispatch(updateOrganizationTariff(payload)).then((res) => {
      if (!res.error) {
        dispatch(
          updateSubscriptionStatus({
            organizationId: res.payload.subscription.id,
            status: "ACTIVE",
          })
        ).then((res2) => {
          if (!res2.error) {
            onSubmit();
          } else {
            setIsLoading(false);
          }
        });
      }
      setIsLoading(false);
    });
  };

  const handleRemoveOrgSub = () => {
    if (!orgInfo?.subscription?.id) return;
    if (confirm("Удалить подписку организации?")) {
      dispatch(
        deleteOrganizationSubscription({
          subscriptionId: orgInfo?.subscription?.id,
        })
      ).then((res) => {
        if (!res.error) {
          onSubmit();
        } else {
          toast.error(res.payload);
        }
      });
    }
  };

  return (
    <div style={modalStyles.overlay}>
      <div style={modalStyles.modal} ref={modalRef}>
        <CloseButton onClose={onClose} />
        <h1 style={modalStyles.title}>
          Изменить тариф организации "{orgInfo.organizationName}"
        </h1>
        <FormControl style={{ marginTop: 20 }} fullWidth>
          <InputLabel
            style={{ color: "white", backgroundColor: "rgb(31, 36, 46)" }}
            id="demo-simple-select-label"
          >
            Тариф
          </InputLabel>
          <Select
            sx={{
              color: "white",
              ".MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(228, 219, 233, 0.25)",
              },
              "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(228, 219, 233, 0.25)",
              },
              "&:hover .MuiOutlinedInput-notchedOutline": {
                borderColor: "rgba(228, 219, 233, 0.25)",
              },
              ".MuiSvgIcon-root ": {
                fill: "white !important",
              },
            }}
            value={currentChosenTariff}
            style={{ color: "white" }}
            label="Тариф"
            onChange={(event) => {
              setCurrentChosenTariff(event.target.value);
            }}
          >
            {tariffesArray.map((tariff) => (
              <MenuItem value={tariff.id}>{tariff.name}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <div
          style={{
            padding: 20,
            paddingTop: 10,
            paddingBottom: 10,
            borderRadius: 5,
            marginTop: 16,
            backgroundColor: "rgba(228, 219, 233, 0.25)",
            color: "white",
            cursor: "pointer",
          }}
          onClick={handleRemoveOrgSub}
        >
          Удалить
        </div>
        <button
          onClick={() => {
            if (!isLoading) {
              setIsLoading(true);
              handleSaveChanges();
            }
          }}
          disabled={isLoading}
          style={
            isLoading
              ? modalStyles.submitButtonDisabled
              : modalStyles.submitButton
          }
        >
          {isLoading ? <span>Сохраняем...</span> : "Сохранить"}
        </button>
      </div>
    </div>
  );
};

const modalStyles = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: "rgba(0, 0, 0, 0.75)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 101,
  },
  modal: {
    width: "40%",
    backgroundColor: "#1f242e",
    borderRadius: "16px",
    // height: "40%",
    padding: "32px",
    position: "relative",
    overflow: "auto",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    scrollbarWidth: "none" /* Firefox */,
    msOverflowStyle: "none" /* IE and Edge */,
    "&::-webkit-scrollbar": {
      /* Chrome, Safari and Opera */ display: "none",
    },
  },
  contentContainer: {
    width: "100%",
    height: "500px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    marginBottom: "32px",
  },
  title: {
    color: "#c1c4cb",
    fontSize: "24px",
    fontWeight: 600,

    fontFamily: "NT Somic",
    marginBottom: "32px",
    textAlign: "center",
  },
  tabContainer: {
    display: "flex",
    gap: "4px",
    marginBottom: "24px",
    justifyContent: "center",
    width: "400px",
  },
  tab: {
    padding: "8px 24px",
    borderRadius: "80px",
    border: "1px solid #333b4b",
    backgroundColor: "#1f242e",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    flex: 1,
    //maxWidth: "130px",
    whiteSpace: "nowrap",
    overflow: "visible",
  },
  activeTab: {
    backgroundColor: "#333b4b",
    color: "#e8f2ff",
  },
  input: {
    width: "400px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    height: "56px",
    minHeight: "56px",
    maxHeight: "56px",
    lineHeight: "1.5",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  lilInput: {
    width: "130px",
    padding: "16px",
    paddingTop: "4px",
    paddingBottom: "4px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    height: "32px",
    minHeight: "32px",
    maxHeight: "32px",
    lineHeight: "1.5",
    boxSizing: "border-box",
    overflowY: "auto",
  },
  textarea: {
    width: "400px",
    height: "100px",
    padding: "16px",
    fontFamily: "NT Somic",
    backgroundColor: "transparent",
    border: "1px solid #333b4b",
    borderRadius: "8px",
    color: "#717b8e",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    resize: "none",
    boxSizing: "border-box",
  },
  uploadArea: {
    width: "400px",
    height: "70px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "8px",
    boxSizing: "border-box",
  },
  uploadIcon: {
    width: "32px",
    height: "32px",
    marginBottom: "8px",
  },
  uploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
  },
  uploadLimit: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
  },
  submitButton: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    color: "#1f242e",
    fontSize: "16px",
    width: "100%",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    ":hover": {
      opacity: 0.9,
    },
    ":disabled": {
      opacity: 0.5,
      cursor: "default",
    },
    marginTop: "32px",
  },
  submitButtonDisabled: {
    padding: "16px 32px",
    backgroundColor: "#e8f2ff",
    borderRadius: "80px",
    border: "none",
    width: "100%",
    color: "#1f242e",
    fontSize: "16px",
    fontWeight: 500,
    cursor: "pointer",
    alignSelf: "center",
    opacity: 0.5,
    cursor: "default",
    marginTop: "32px",
  },
  versionUploadArea: {
    width: "400px",
    height: "144px",
    border: "1px dashed #333b4b",
    borderRadius: "8px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    cursor: "pointer",
    marginBottom: "16px",
    boxSizing: "border-box",
  },
  versionUploadIcon: {
    width: "32px",
    height: "32px",
    marginBottom: "16px",
  },
  versionUploadText: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginBottom: "8px",
    textAlign: "center",
  },
  versionUploadSubtext: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    textAlign: "center",
    maxWidth: "400px",
  },
  versionLabel: {
    color: "#c1c4cb",
    fontSize: "16px",
    fontWeight: 500,
    marginTop: "8px",
  },
  loadingSpinner: {
    width: "32px",
    height: "32px",
    border: "3px solid #333b4b",
    borderTop: "3px solid #e8f2ff",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
    marginBottom: "16px",
  },
  uploadProgress: {
    color: "#717b8e",
    fontSize: "14px",
    fontWeight: 500,
    marginTop: "8px",
  },
  versionThumbnail: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: "8px",
  },
};

export default OrganizationChangeTariffModal;
